import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RemoveCircleOutline } from "@material-ui/icons";
import { clearCart, deleteProduct } from "../redux/cartRedux";
import { useDispatch } from "react-redux";
import Footer from "../components/Footer";

const Container = styled.div`
  min-height: calc(100vh - 60px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    font-weight: 200;
    text-align: center;
  }
`;
const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;

  @media only screen and (max-width: 768px) {
    .list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    button {
      display: none;
    }
  }

  .continue {
    padding: 20px;
    font-weight: 600;
    font-size: 13px;
    text-decoration: none;
    background-color: black;
    color: white;
    border: none;
    border-radius: 5px;
  }

  button {
    padding: 20px;
    font-weight: 600;
    cursor: pointer;
    background-color: black;
    color: white;
    border: none;
    border-radius: 5px;
  }

  span {
    text-decoration: underline;
    cursor: pointer;
    margin: 0 10px;
  }
`;
const Bottom = styled.div`
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const Products = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-left: 0px;
`;
const Product = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 0;
  border-bottom: solid 1px black;

  &:last-child {
    border-bottom: none;
  }

  @media only screen and (max-width: 768px) {
    .left {
      img {
        width: 100px !important;
        height: 100px !important;
      }
    }
  }

  .left {
    display: flex;
    align-items: center;

    img {
      width: 150px;
      height: 150px;
      object-fit: cover;
      border-radius: 5px;
    }

    .details {
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .color-wrapper {
        display: flex;
        align-items: center;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;

    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }

    span {
      font-size: 24px;
      margin: 5px;
      font-weight: 200;
    }

    .icon {
      height: 30px;
      width: 30px;
      margin-left: 15px;
      cursor: pointer;
      @media only screen and (max-width: 768px) {
        margin-left: 0;
      }
    }
  }
`;
const Color = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background-color: ${props => props.color};
  margin: 0px 5px;
  cursor: pointer;
`;
const Summary = styled.div`
  flex: 1;
  border: 0.5px solid black;
  border-radius: 10px;
  padding: 20px;

  h2 {
    font-weight: 200;
  }

  .item {
    margin: 30px 0px;
    display: flex;
    justify-content: space-between;

    &.total {
      font-weight: 500;
      font-size: 24px;
    }
  }

  button,
  .button {
    width: 100%;
    padding: 20px;
    background-color: black;
    border: none;
    border-radius: 10px;
    color: white;
    font-weight: 600;
  }
`;

export default function Cart() {
  const products = useSelector(state => state.cart.products);
  const cart = useSelector(state => state.cart);
  const shippingCost = 5.9;
  const shippingDiscount = 5.9;
  const dispatch = useDispatch();

  const handleClear = () => {
    dispatch(clearCart());
  };
  const handleDelete = e => {
    const target = e.currentTarget.getAttribute("cartid");
    const value = e.currentTarget.getAttribute("value");
    dispatch(deleteProduct({ target, value }));
  };

  return (
    <Container>
      <div className="wrapper">
        <h2>YOUR CART</h2>
        <Top>
          <Link to="/products" className="continue">
            CONTINUE SHOPPING
          </Link>
          <div className="list">
            <span>Shopping Cart (2)</span>
            <span>Your Whislist (0)</span>
          </div>
          <button onClick={handleClear}>CLEAR CART</button>
        </Top>
        <Bottom>
          <Products>
            {products.map((item, i) => (
              <Product key={i}>
                <div className="left">
                  <img src={item.img} alt="" />
                  <div className="details">
                    <span>
                      <b>Product:</b> {item.title}
                    </span>
                    <span>
                      <b>Cart ID:</b> {item.cartId}
                    </span>
                    <span className="color-wrapper">
                      <b>Color: </b>
                      <Color color={item.color} />
                    </span>
                    <span>
                      <b>Size:</b> {item.size}
                    </span>
                    <span>
                      <b>Quantity: </b>
                      {item.quantity}
                    </span>
                  </div>
                </div>
                <div className="right">
                  <span className="price">£{item.price * item.quantity}</span>
                  <RemoveCircleOutline
                    className="icon"
                    cartid={item.cartId}
                    value={item.price * item.quantity}
                    onClick={handleDelete}
                  />
                </div>
              </Product>
            ))}
          </Products>
          <Summary>
            <h2>ORDER SUMMARY</h2>
            <div className="item">
              <span>Subtotal</span>
              <span>£{cart.total}</span>
            </div>
            <div className="item">
              <span>Estimated Shipping</span>
              <span>£{shippingCost}0</span>
            </div>
            <div className="item">
              <span>Shipping Discount</span>
              <span>-£{shippingDiscount}0</span>
            </div>
            <div className="item total">
              <span>Total</span>
              <span>£{cart.total + shippingCost - shippingDiscount}</span>
            </div>
            <Link className="button" to="/payment">
              CHECKOUT
            </Link>
          </Summary>
        </Bottom>
      </div>
      <Footer />
    </Container>
  );
}
